var Cookies = require('js-cookie')
export default function signout() {
    sessionStorage.clear();
    Cookies.remove('token')
    Cookies.remove('permissions')
    window.location.href = "/";
}